import { useEffect } from "react";
import { useParams } from "react-router-dom";

import defaultLogo from "../../../assets/logo.svg";

const apiUrl = process.env.REACT_APP_API_URL?.trim();

function TenantLogoRedirect() {
  const { publicTenantId } = useParams();

  useEffect(() => {
    if (!apiUrl || !publicTenantId) return;

    const targetUrl = `${apiUrl}/tenants/${publicTenantId}/logo`;
    window.location.replace(targetUrl);
  }, [publicTenantId]);

  return <img src={defaultLogo} alt="Tenant Logo" />;
}

export default TenantLogoRedirect;
